/**
 * ========================================
 * App - Main Router Component
 * ========================================
 */

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { adminAuth } from './services/api.service';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import SpotManagement from './pages/SpotManagement';
import GradeSettings from './pages/GradeSettings';

// Protected Route Component
function ProtectedRoute({ children }) {
  const isAuthenticated = adminAuth.isAuthenticated();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />

        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/spots"
          element={
            <ProtectedRoute>
              <SpotManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/grade-settings"
          element={
            <ProtectedRoute>
              <GradeSettings />
            </ProtectedRoute>
          }
        />

        {/* Default Redirect */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
